import { authHeader } from "../helpers";
import { defineConfig } from '../config'
import { utilsService } from "./utils";
const { handleResponse } = utilsService;

export const mailService = {
  sendMail,
};

const { apiUrl, apiVer } = defineConfig.MAIL_SERVICE;

function getApiPath(){
  return (apiUrl + "/" + apiVer + "/email");
}

function sendMail(toEmail, content) {
  const url = getApiPath() + `/create/MM?toEmail=${toEmail}`;
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(content)
  };
  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}